import React, { useEffect, useContext, useState } from 'react';
import AccountComponent from 'organisms/AccountPage/AU/Container/AccountContainer';
import { UserOrderContext } from 'context/context';
import HEADER_CONSTANT from 'organisms/HeaderComponent/AU/HeaderConstants/HeaderConstant';

const AccountContainer = props => {
  const [showKfcHeader, setShowKfcHeader] = useState(true);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { dispositionStateData = {}, scheduleOrderData = {}, searchStoreData = {} } = userOrderState;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const hideNavbarFlag = Boolean(
      dispositionStateData?.showDisposition ||
        searchStoreData?.showSearchStore ||
        scheduleOrderData.showScheduleOrderCatering,
    );
    userOrderStateDispatch({
      type: HEADER_CONSTANT.SET_HIDE_NAV_BARS,
      value: { flag: !showKfcHeader && !hideNavbarFlag },
    });
  }, [
    showKfcHeader,
    dispositionStateData?.showDisposition,
    searchStoreData?.showSearchStore,
    scheduleOrderData.showScheduleOrderCatering,
    userOrderStateDispatch,
  ]);
  useEffect(() => {
    return () => {
      userOrderStateDispatch({ type: HEADER_CONSTANT.SET_HIDE_NAV_BARS, value: { flag: false } });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <AccountComponent history={props.history} setShowKfcHeader={value => setShowKfcHeader(value)} />
    </React.Fragment>
  );
};

export default AccountContainer;
